'use strict'
import { App, View, Controller } from '../config/app.js'
import { i18n, hasRole } from '../helper.js'

class StoreController extends Controller
{
	async account()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'store', tab: 'account' }

		const steps = await App.Store.fetch('storestep')
		let stepCurrent = Object.values(steps).find(step => !step.attributes.complete) // Last incompete step
		if (!stepCurrent)
			stepCurrent = Object.values(steps).findLast(step => step.attributes.name == 'Finished') // Finished step

		return App.Store.page('storestep', stepCurrent.id, 1, { include: '*' })
			.then(results =>
			{
				if (results[stepCurrent.id].attributes.name !== "Stripe")
					return
				const stripeCode = new URL(document.location).searchParams.get('code')
				if (stripeCode)
				{
					App.Store.model('storestep', stepCurrent.id).attributes.stripe.authCode = stripeCode
					window.history.replaceState(null, document.title, document.location.pathname)
				}
			})
			.finally(_ => this.view.render())
	}

	async coupons()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'store', tab: 'coupon' }
		App.Store.page('coupon', 1, 0, { include: ['usage'] }).catch(() => { })
		this.view.render()
	}

	async products()
	{
		if (hasRole('Administrator'))
			App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'products', group: 'dashboard' }
		else if (hasRole('Practitioner'))
			App.Store.model('customer', App.Config.customerId).myaccount = { group: 'store', tab: 'products' }

		App.Store.fetch('storeproduct', 0).catch(() => { })
		this.view.render()
	}

	async orders()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'patient', tab: 'order' }
		App.View.create(
			{
				name: 'grid/orderPatientSummary',
				model: App.Store.model('ordersummary')
			})
		this.view.render()
	}

	async patients()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'patient', tab: 'registered' }
		App.Store.page('storecustomer', 1).catch(() => { })
		this.view.render()
	}

	async practice()
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'store', tab: 'practice' }

		return Promise.all(
			[
				App.Store.fetch('country', 0, { include: 'stateProvince' }),
				App.Store.fetch('storestep', 'Practice', { include: '*' })
			])
			.then(results =>
			{
				this.view.model.sync(results[1])
			})
			.finally(_ => this.view.render())
	}

	async pricing()
	{
		let hcpCode = App.Store.model('customer', App.Config.customerId).attributes?.ownedStoreId || '';
		let storeData = {}
		App.Store.model('customer', App.Config.customerId).myaccount = { group: 'store', tab: 'pricing' }
		const promises = [
			App.Store.fetch('store', hcpCode, { include: 'maxdiscount,msrp' })
				.then(data => storeData = data).catch(() => { }),
			App.Store.fetch('topic', 'MyAccount.Store.Pricing').catch(() => { })
		]
		await Promise.all(promises)
		const increase = i18n('myaccount.store.pricing.option-increase').split('_')
		const decrease = i18n('myaccount.store.pricing.option-discount')
			.replace(/MaxDiscount/g, storeData.attributes.maxDiscount).split('_')
		this.view.model.sync({
			increaseFirst: increase[0],
			increaseSecond: increase[1],
			decreaseFirst: decrease[0],
			decreaseSecond: decrease[1]
		})
		this.view.model.sync(storeData)
		this.view.render()
	}

	async notfound()
	{
		return App.Store.fetch('topic', 'Apex.StoreNotFound')
			.finally(() => this.view.render())
	}

	async reorder(reorderId)
	{
		App.Store.model('customer', App.Config.customerId).myaccount = { tab: 'reorder', group: 'patient' }
		if (reorderId)
		{
			if (App.Store.paging('reorder'))
				App.Store.pagingReset('reorder')

			this.view.model.reorderId = reorderId

			let viewDetail = App.View.cache('account/reorderDetail') || View.create({ name: 'account/reorderDetail' })

			App.Store.fetch('reorder', reorderId, { include: '*' })
				.then(reorderDetail => viewDetail.model.sync(reorderDetail))
				.catch(err => viewDetail.model.sync({ error: true, errorMessage: Helper.getErrorMessage(err) }))
		}
		else
		{
			App.Store.page('reorder', 1, 20, { include: 'product.price' })
		}

		this.view.render()
	}
}

export { StoreController }
